import { Chip, Typography } from '@mui/material';
import DrilldownDialog from './DrilldownDialog';
import { Date1, Stack2, digits } from './drilldownCells';
import { REASON_LABEL, replacementsUrl } from './tutorReplacements';

// The popup behind a number on the Tutor Replacement Count pages: one row per replacement, newest first, so the rows add up to the
// number that was clicked. Who the student is, what was taught, which CRO, the tutor who was replaced and the one who took over, and why.
const text = (value) => (value || '').toLowerCase();

const COLUMNS = [
  { key: 'replacedOn', label: 'Replaced on', sort: (r) => r.replacedOn || '', render: (r) => <Date1 value={r.replacedOn} />, csv: (r) => r.replacedOn },
  { key: 'student', label: 'Student', sort: (r) => text(r.studentName), render: (r) => <Typography variant="body2" fontWeight={600}>{r.studentName || '-'}</Typography>, csv: (r) => r.studentName },
  {
    key: 'course', label: 'Course / subject', sort: (r) => text(r.courseName),
    render: (r) => <Stack2 top={r.courseName} bottom={r.subjectName} />, csv: (r) => [r.courseName, r.subjectName].filter(Boolean).join(' / '),
  },
  { key: 'cro', label: 'CRO', sort: (r) => text(r.croName), render: (r) => <Typography variant="body2">{r.croName || '-'}</Typography>, csv: (r) => r.croName },
  {
    key: 'oldTutor', label: 'Replaced tutor', sort: (r) => text(r.oldTutorName),
    render: (r) => <Stack2 top={r.oldTutorName} bottom={r.oldTutorMobile} />, csv: (r) => [r.oldTutorName, r.oldTutorMobile].filter(Boolean).join(' '),
  },
  {
    key: 'newTutor', label: 'New tutor', sort: (r) => text(r.newTutorName),
    render: (r) => <Stack2 top={r.newTutorName} bottom={r.newTutorMobile} />, csv: (r) => [r.newTutorName, r.newTutorMobile].filter(Boolean).join(' '),
  },
  {
    key: 'reason', label: 'Reason', sort: (r) => text(r.replacementReason),
    render: (r) => (
      <div>
        <Typography variant="body2">{r.replacementReason || '-'}</Typography>
        <Chip size="small" variant="outlined" label={REASON_LABEL[r.category] || REASON_LABEL.other} sx={{ mt: 0.25 }} />
      </div>
    ),
    csv: (r) => [r.replacementReason, REASON_LABEL[r.category] || REASON_LABEL.other].filter(Boolean).join(' - '),
  },
];

const searchText = (r) => [r.studentName, r.courseName, r.subjectName, r.croName, r.oldTutorName, r.newTutorName, r.replacementReason,
  digits(r.oldTutorMobile), r.oldTutorMobile, digits(r.newTutorMobile), r.newTutorMobile].filter(Boolean).join(' ').toLowerCase();

const TutorReplacementsDialog = ({ request, onClose }) => {
  const { name, reason, month } = request;
  const chips = [name, month.format('MMMM YYYY')];
  if (reason) chips.push(REASON_LABEL[reason]);
  return (
    <DrilldownDialog
      url={replacementsUrl(request)}
      title="Tutor replacements"
      chips={chips}
      columns={COLUMNS}
      searchText={searchText}
      searchLabel="Search these replacements"
      searchPlaceholder="Search student, course, CRO, tutor, reason"
      emptyText="No tutor replacements."
      rowKey={(r) => r.id}
      csvName={`Tutor_replacements_${(name || 'all').replace(/\W+/g, '_')}${reason ? `_${reason}` : ''}_${month.format('YYYY-MM')}.csv`}
      onClose={onClose}
    />
  );
};

export default TutorReplacementsDialog;
